<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" [style.background-color]="page.backgroundColor" style="min-height: 100vh;">
  <div *ngIf="initialized && found && page.id != 781 && page.id != 1350 && page.id != 610 && page.id != 714" [class]="page.containerClass">
    <bxl-page-element *ngFor="let element of page.elements" [element]="element" [conference]="conference"></bxl-page-element>
  </div>

  <div *ngIf="initialized && found && (page.id == 781 || page.id == 1350) " style="background-color: black">
    <div [class]="page.containerClass" style="background-image: url(https://bxlimages.blob.core.windows.net/images/DisruptExplosion_fadeblack.jpg); background-position: start center; background-repeat: no-repeat; background-size: contain; padding-bottom: 80px; padding-top: 80px">
      <div class="container">
        <bxl-page-element *ngFor="let element of page.elements" [element]="element" [conference]="conference"></bxl-page-element>
      </div>
    </div>
  </div>
  <!-- <div *ngIf="initialized && found && page.id == 1017" style="background-color: #041d40">
    <div [class]="page.containerClass">
      <div class="container">
        <bxl-page-element *ngFor="let element of page.elements" [element]="element" [conference]="conference"></bxl-page-element>
      </div>
    </div>
  </div> -->

  <div *ngIf="initialized && found && page.id == 714" style="background-color: #842827">
    <div [class]="page.containerClass">
      <div class="container">
        <bxl-page-element *ngFor="let element of page.elements" [element]="element" [conference]="conference"></bxl-page-element>
      </div>
    </div>
  </div>

  <div *ngIf="initialized && found && page.id == 610" [class]="page.containerClass" style="background-image: url(/fetchImage?filename=02bbf915-38d2-422f-af66-e8399e1ec2afDisrupt_Header1140_NoLogo_Explosion2.jpg); background-position: center center; background-size: cover; padding-bottom: 80px; padding-top: 80px">
    <div class="container">
      <div  *ngFor="let element of page.elements" class="mt-2">
      <bxl-page-element [element]="element" [conference]="conference"></bxl-page-element>
    </div>
    </div>
  </div>

  <div *ngIf="initialized && !found" class="space-1">
    <div class="row no-gutters no-candidates" style="height: 300px; border: 0">
      <div class="col-sm-12 my-auto">
        <h1><i class="fas fa-empty-set"></i></h1>
        <h4>Page Not Found</h4>
        <p>The page you are trying to access doesn't exist. Please try again.</p>
        <a [routerLink]="['../']" class="btn btn-instagram">Home</a>
      </div>
    </div>
  </div>
</div>
